export class DomainError extends Error {
    type;
    url;
    debug;
    error;
    name = 'DomainError';
    constructor(type, url, debug, error) {
        super(`DomainError: ${type}`);
        this.type = type;
        this.url = url;
        this.debug = debug;
        this.error = error;
    }
}
//# sourceMappingURL=DomainError.js.map